// extracted by mini-css-extract-plugin
export default {"fullWidth":"OH-z","image":"PH-z","lazyLoadPicture":"QH-z","lazyLoadSpinner":"RH-z","lazyLoadSpin":"SH-z","lazyLoadImage":"TH-z","hasStyledAspectRatio":"UH-z"};